import React, { Component } from 'react';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

class Editor extends Component {

    state = {
        kundenBesonderheiten: ""
    }
    render() {       
        return (
            <div className="App">
                {/* <h2>Using CKEditor 5 build in React</h2> */}
                <CKEditor
                    disabled= {this.props.disabled}
                    config= {{
                        fullPage: true,
                        removePlugins: [ 'Image', 'ImageToolbar', 'ImageCaption', 'ImageStyle', 'ImageTextAlternative', 'ImageUpload', 'MediaEmbed',  ],
                        toolbar: [ 'bold', 'italic', 'bulletedList', 'numberedList' ],
                        disabled: true
                    }}
                    editor={ ClassicEditor }
                    data={this.props.App.KundenBesonderheiten || ""}
                    onInit={ editor => {
                        // You can store the "editor" and use when it is needed.
                       // console.log( 'Editor is ready to use!', editor );
                    } }
                    onChange={ ( event, editor ) => {
                        const data = editor.getData();
                        this.props.SetPropertyValue(this.props.App, 'KundenBesonderheiten', data);
                        this.setState({kundenBesonderheiten: data});
                       // console.log( { event, editor, data } );
                    } }
                    onBlur={ editor => {
                        //console.log( 'Blur.', editor );
                        this.props.SaveData(this.props.App, { KundenBesonderheiten : this.state.kundenBesonderheiten !== "" ?  this.state.kundenBesonderheiten : (this.props.App.KundenBesonderheiten || "") })
                    } }
                    onFocus={ editor => {
                        console.log( 'Focus.', editor );
                    } }
                />
            </div>
        );
    }
}

export default Editor;